import { NavLink } from "react-router-dom";
import resetIcon from "../../../assets/OpenAIChat/reset.png";
import styles from "./Layout.module.scss";
import { FC, useContext } from "react";
import sms_icon from "../../../assets/OpenAIChat/sms.png";
import { SettingsContext } from "context";

export const OpenAIChatLayout: FC<any> = (props: any) => {
  const { currentDemo } = useContext(SettingsContext);

  const setClearChat = () => {
    props.onsetClearChat();
  };

  return (
    <div className={styles.layout}>
      <header className={styles.header} role={"banner"}>
        <div className={styles.headerContainer}>
          <p className={styles.headerRightText} style={{ color: "white" }}>
            Azure OpenAI + Cognitive Search
          </p>
          <ul className={styles.headerNavList}>
            <li>
              <div
                style={{ cursor: "pointer" }}
                className={styles.headerNavPageLink}
                title="Reset Demo"
                onClick={() => {
                  setClearChat();
                }}
              >
                <img className={styles.icon} src={resetIcon} alt="reset" />
                <span className={styles.headerNavListtext}>Reset Demo</span>
              </div>
            </li>
            <li className={styles.headerNavLeftMargin}>
              <NavLink
                to={`/${currentDemo?.guid}/chat-bot`}
                className={({ isActive }) =>
                  isActive
                    ? styles.headerNavPageLinkActive
                    : styles.headerNavPageLink
                }
              >
                <img className={styles.icon} src={sms_icon} alt="chat" />
                <span className={styles.headerNavListtext}>Chat</span>
              </NavLink>
            </li>

            {/* <li className={styles.headerNavLeftMargin}>
              <SettingsButton
                className={styles.settingsButton}
                onClick={() => setConfigPanel(true)}
              />
            </li> */}
          </ul>
        </div>
      </header>
      <div></div>
      {props.children}
    </div>
  );
};
